import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/site/Layout";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/site/ProtectedRoute";
import About from "@/pages/About";
import { ConditionsIndex, ConditionDetail } from "@/pages/Conditions";
import Booking from "@/pages/Booking";
import Reviews from "@/pages/Reviews";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<About />} />
            <Route path="/conditions" element={<ConditionsIndex />} />
            <Route path="/conditions/:slug" element={<ConditionDetail />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<About />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
